import eventQueue from '../queue';
import { EventAction, EventSurface } from '../../types/events';
import { checkLinkApiRequestParamsLengthAndContainsKeys } from '../utils';
function attachEventListeners() {
    eventQueue.on('link_api_request', function (_a) {
        var state = _a.state, params = _a.params, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (checkLinkApiRequestParamsLengthAndContainsKeys(params, ['id'], 1) &&
            state.segment.currentSource ===
                EventSurface.PROVIDER_CONFIRMATION_UNBOUNDED) {
            fireAnalyticsEvent(EventAction.TRY_GENERIC_PLATFORM);
        }
    });
}
attachEventListeners();
